<template>
    <div>
        <div v-if="saving" class=" text-center alert alert-info">Saving</div>
        <div v-for="(gender,index) in Object.keys(groupedCategories)" class="panel panel-default">
            <div class="panel-heading">
                {{ genders[gender] }}

                <div class="pull-right">
                    <button type="button" class="btn btn-xs btn-success" @click="addNewCategoryToGender(gender)">Add new</button>
                </div>
            </div>
            <div class="panel-body">

                <div class="row header" v-if="groupedCategories[gender].length>0">
                    <div class="col-md-3">Name</div>
                    <div class="col-md-3">Age From</div>
                    <div class="col-md-3">Age To</div>
                </div>
                <div v-for="(category,index) in groupedCategories[gender]"  class="row category_item">
                    <div class="col-md-3">
                        <input type="text" class="form-control" v-model="category.name" @blur="saveAllInGenders(gender)">
                    </div>

                    <div class="col-md-3">
                        <input type="number" class="form-control" v-model="category.age_from" @blur="saveAllInGenders(gender)">
                    </div>
                    <div class="col-md-3">
                        <input type="number" class="form-control" v-model="category.age_to" @blur="saveAllInGenders(gender)">
                    </div>
                    <div class="col-md-1">
                        <button type="button" class="btn btn-xs btn-danger" @click="deleteCategory(category,gender,index)">Delete
                        </button>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: {
        genders: {
            type: Object
        },
        ageCategories: {
            type: Array,
        },
        ageCategoryProfileId: {
            type: Number
        },
        groupedAgeCategoriesForProfile: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            groupedCategories: this.groupedAgeCategoriesForProfile,
            errors: {},
            saving: false
        }
    },
    created() {
        Object.keys(this.groupedCategories).map(gender => {
            this.errors[gender] = [];
        })
    },
    watch: {
        saving() {
            if (this.saving) {
                setTimeout(() => {
                    this.saving = false;
                }, 1000)
            }
        }
    },
    methods: {

        async editCategory(category, gender, index) {
            let res = await axios.put(`/api/internal/AgeCategories/edit/${category.id}.json`, category)
        },
        async saveCategory(category, gender, index) {
            let res = await axios.post(`/api/internal/AgeCategories/add.json`, category)
            if (res.data.entity.id) {
                Vue.set(this.groupedCategories[gender][index], 'id', res.data.entity.id)
            } else {
                this.errors[gender].push(res.data.errors);
            }

        },
        deleteCategory(category, gender, index) {
            if (category.id) {
                axios.delete(`/api/internal/AgeCategories/delete/${category.id}.json`);
            }
            let temp = this.groupedCategories[gender].splice(index, 1);
        },
        saveAllInGenders(gender) {
            //this.saving = true;
            console.log('on blur called')
            this.groupedCategories[gender].forEach(async (category, index) => {
                if (category.id) {
                    await this.editCategory(category, gender, index)
                } else {
                    await this.saveCategory(category, gender, index)
                }
            })
        },
        addNewCategoryToGender(gender) {
            let temp = {
                name: '',
                age_from: null,
                age_to: null,
                age_category_profile_id: this.ageCategoryProfileId,
                gender: gender
            };
            this.groupedCategories[gender].push(temp);
        }
    }
}
</script>
<style scoped>
.category_item {
    margin-bottom: 10px;
}

.header {
    font-weight: bold;
}

.alert {
    margin-bottom: 8px;
    padding: 0.3em;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AgeCategories/AgeCategories.vue